/* eslint-disable no-console, no-case-declarations, no-unused-vars */
// import axios from "axios";
import { apolloClient } from "@/setup/apollo-setup";
// import { serverResponseStatusSet, error } from '@/utils/notification';

import {
    GET_CHATROOMS,
    GET_CHATROOMS_BY_FILTER,
    GET_CHATROOM_BY_ID,
    GET_CHATROOM_BY_ASSOCIATIVE_KEY,
    SEND_CHATMESSAGES,
} from '@/queries/modules/chat/chat.js';

/**
  *  Action to Get All Chatroom List
  *  ** Use it for development purpose only **
  *
  *   @param  {Object} context Vuex context object.
  *     @property {Vuex method (Function)} commit : "To commit a mutation"
  *
  */

export async function getChatrooms(context) {
  // WIP
  const { commit } = context;
  commit('setProcessing', true);

  try {
    const result = await apolloClient
    .query({
      query: GET_CHATROOMS,
      fetchPolicy: 'network-only',
      context: { clientName: 'Prisma2' }
    })

    const { data } = await result;

    const chatrooms = data.getChatRooms;
    commit("storeChatrooms", chatrooms)

    return { status: { success: true, error: false, message: "" }, data: chatrooms };

  } catch (e) {
    console.log(e);
    // commit('setError', serverResponseStatusSet(e));
    return { status: { success: false, error: true, message: "", full: e }};
  }
}


/**
  *  Action to Get All Chatroom List by Filter (Reduce total chatroom to necessary amount)
  *
  *   @param  {Object} context Vuex context object.
  *     @property {Vuex method (Function)} commit : "To commit a mutation"
  *
  */

export async function getChatroomsByFilter(context) {
  // WIP
  const { commit } = context;
  commit('setProcessing', true);

  try {
    const result = await apolloClient
    .query({
      query: GET_CHATROOMS_BY_FILTER,
      fetchPolicy: 'network-only',
      context: { clientName: 'Prisma2' }
    })

    const { data } = await result;

    const chatrooms = data.getChatRooms;
    commit("storeChatrooms", chatrooms)

    return { status: { success: true, error: false, message: "" }, data: chatrooms };

  } catch (e) {
    console.log(e);
    // commit('setError', serverResponseStatusSet(e));
    return { status: { success: false, error: true, message: "", full: e }};
  }
}


/**
  *  Action to Get Chatroom By Id
  *
  *   @param  {Object} context Vuex context object.
  *     @property {Vuex method (Function)} commit : "To commit a mutation"
  *
  */

export async function getChatroomById(context, { id }) {
  // WIP
  const { commit } = context;
  commit('setProcessing', true);

  try {
    if (!id) throw new Error("No Chatroom Id");

    const variables = {
      id
    }

    console.log(id);

    const result = await apolloClient
    .query({
      query: GET_CHATROOM_BY_ID,
      variables,
      fetchPolicy: 'network-only',
      context: { clientName: 'Prisma2' }
    })

    const { data } = await result;

    const chatroom = data.getChatRoomById;
    // TODO: Update Chatroom to Store and Cache;

    return { status: { success: true, error: false, message: "" }, data: chatroom };

  } catch (e) {
    console.log(e);
    // commit('setError', serverResponseStatusSet(e));
    return { status: { success: false, error: true, message: "", full: e }};
  }
}


/**
  *  Action to Get Chatroom By Associative Key (Feature name and its ID)
  *
  *   @param  {Object} context Vuex context object.
  *     @property {Vuex method (Function)} commit : "To commit a mutation"
  *
  */

export async function getChatroomByAssociativeKey(context, payload) {
  // WIP
  const { commit } = context;
  commit('setProcessing', true);

  const variables = payload;

  try {
    const result = await apolloClient
    .query({
      query: GET_CHATROOM_BY_ASSOCIATIVE_KEY,
      variables,
      fetchPolicy: 'network-only',
      context: { clientName: 'Prisma2' }
    });

    const { data } = result;

    const chatroom = data.getChatRoomByAssociativeKey;

    return { status: { success: true, error: false, message: "" }, data: chatroom };

  } catch (e) {
    console.log(e);
    // commit('setError', serverResponseStatusSet(e));
    return { status: { success: false, error: true, message: "", full: e }};
  }
}


/**
  *  Action to Send Chat Message
  *
  *   @param  {Object} context Vuex context object.
  *     @property {Vuex method (Function)} commit : "To commit a mutation"
  *
  */

export async function sendChatMessages(context, payload) {
  const { commit } = context;
  commit('setProcessing', true);

  // const { chatroomId, chatMessagesInput } = payload;
  const variables = payload;

  try {
    const result = await apolloClient
    .mutate({
      mutation: SEND_CHATMESSAGES,
      variables,
      context: { clientName: 'Prisma2' }
    });

    const { data } = result;

    const chatMessageSentResult = data.sendChatMessages;
    // commit("storeChatrooms", chatrooms)

    return { status: { success: true, error: false, message: "" }, data: chatMessageSentResult };

  } catch (e) {
    console.log(e);
    // commit('setError', serverResponseStatusSet(e));
    return { status: { success: false, error: true, message: "", full: e }};
  }
}
